import axios from "axios";

import { envConfig } from "../constants";
import { handleUnAuthorized } from "../utils/authUtils";

/**
 * API class to create axios instances by passing base URL.
 */
export class APIInstance {
  /** @type {string} */
  #baseURL;
  /** @type {string} */
  #path;
  /** @type {import("axios").AxiosInstance} */
  api;

  /** @param {{baseURL?: string, path?: string}} param */
  constructor({ baseURL, path }: { baseURL?: string; path?: string } = {}) {
    this.#baseURL = baseURL || envConfig.API_BASE_URL;
    this.#path = path || "";
    this.api = this.#createAxiosInstance();
    this.#setRequestInterceptor();
    this.#setResponseInterceptor();
    // TODO: handling pending requests
    // this.pending = {};
    // this.CancelToken = axios.CancelToken;
    // this.setCancelPendingInterceptor(this.api);
  }

  /**
   * Create an axios instance with passed base URL and path
   * @returns {import("axios").AxiosInstance}
   */
  #createAxiosInstance() {
    return axios.create({
      baseURL: this.#baseURL + this.#path,
      timeout: 10000, // Set a timeout limit
      headers: { "Content-Type": "application/json" },
      withCredentials: true, // Include cookies in requests if needed
    });
  }

  #setRequestInterceptor() {
    // Request interceptor — auth is handled via httpOnly cookie (withCredentials: true)
    this.api.interceptors.request.use((config) => {
      config.headers["x-timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return config;
    });
  }

  #setResponseInterceptor() {
    // Response interceptor
    this.api.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        const { response } = error;
        if (response?.config?.skipAuth) {
          return Promise.reject(error);
        }
        if ([401].includes(response.status)) {
          console.log("Unauthorized, redirecting to login...");
          handleUnAuthorized(window.location.hash);
        } else if ([403].includes(response.status)) {
          console.log("Forbidden, you have no permission");
        }
        return Promise.reject(error);
      },
    );
  }
}
